import _ from 'lodash';

export function initTargeting() {
  return { regions: [], markets: [], states: [], store_number: [] };
}

export function targetingFromAPI(targeting) {
  if (!targeting) return initTargeting();
  const obj = _.isString(targeting) ? JSON.parse(targeting) : targeting;
  return {
    regions: obj.region || [],
    markets: obj.market || [],
    states: obj.state || [],
    store_number: obj.store_number || [],
  };
}

export function targetingToAPI(targeting) {
  const obj = {
    region: targeting.regions || null,
    market: targeting.markets || null,
    state: targeting.states || null,
    store_number: targeting.store_number || null,
  };
  return _.omitBy(obj, _.isEmpty);
}

export function trimTargeting(targeting) {
  return _.mapValues(targeting, (values) => _.map(values, _.trim));
}
